@let loginRecoveryOptionValue = loginRecoveryOption();

<div class="recovery-email-sent">
  <div class="recovery-email-sent__header">
    <div class="recovery-email-sent__icon-background">
      <i class="fa-regular fa-check recovery-email-sent__icon"></i>
    </div>
    <div class="recovery-email-sent__header-title">{{ 'login.recovery.email-sent.title' | translate }}</div>
  </div>

  <div class="recovery-email-sent__content">
    @switch (loginRecoveryOptionValue) {
      @case (LoginRecoveryOption.Password) {
        <itc-recover-password-email-sent />
      }
      @case (LoginRecoveryOption.Username) {
        <itc-recover-username-email-sent />
      }
      @case (LoginRecoveryOption.CompanyName) {
        <itc-recover-company-name-email-sent />
      }
    }

    <div class="recovery-email-sent__description">{{ 'login.recovery.email-sent.description' | translate }}</div>

    @if (loginRecoveryOptionValue !== LoginRecoveryOption.CompanyName) {
      <div class="recovery-email-sent__additional-description">
        <span class="recovery-email-sent__additional-description--bold">
          {{ 'login.recovery.email-sent.additional-description.part-1' | translate }}
        </span>
        {{ 'login.recovery.email-sent.additional-description.part-2' | translate }}
      </div>
    }
  </div>

  <div class="recovery-email-sent__buttons">
    <kds-large-button [buttonText]="'login.recovery.buttons.back-to-login' | translate" (buttonClick)="backToLogin()" />
  </div>
</div>
